import { inject } from "@angular/core";
import { ResolveFn, ActivatedRouteSnapshot, RedirectCommand, Router } from "@angular/router";
import { catchError, map, of, switchMap } from "rxjs";
import { Dealer } from "../../dto/dealer.model";
import { Listing } from "../../dto/listing.model";
import { DealerService } from "../dealer.service";
import { ListingsService } from "../listings.service";

export const dealerResolver: ResolveFn<{ dealer: Dealer, listings: Listing[] } | RedirectCommand> = (route: ActivatedRouteSnapshot) => {
    const listingService = inject(ListingsService);
    const dealerService = inject(DealerService);
    const router = inject(Router);
    const slug = route.paramMap.get('slug')!;

    return dealerService.getBySlug(slug)
        .pipe(
            switchMap(dealer => {
                return listingService.getForDealer(dealer.id)
                    .pipe(
                        map(
                            listings => {
                                return {
                                    'dealer': dealer,
                                    'listings': listings
                                };
                            }
                        )
                    );
            }),
            catchError((error) => {
                console.error('Error fetching dealer:', error);
                return of(new RedirectCommand(router.parseUrl('/')));
            }),
        );
}